// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 3768) return "static/chunks/3768-3065136d9d5cde17.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"55":"b92e24f8f7ca7e6e","2883":"71705dd0fa4f5c55","3046":"a8eccbc435504263","5492":"dff38e712961b603","6693":"b1fb41b9f1c2364d","9175":"a4ec8e2e816dbd3f","9306":"ea5c49e5f33f6beb","9722":"e1f0e577813c9a12"}[chunkId] + ".js";
};